import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    shareinfos(data) {
        return axios.request({
            url: "api/shareinfos",
            method: "post",
            data
        });
    },
    wxLoginWap(data) {
        return axios.request({
            url: "user/login-wx-wap",
            method: "post",
            data
        });
    },
    appLaunch() {
        return axios.request({
            url: "api/launch"
        })
    },
    upload({content, imgkey}) {

        var formData = new FormData();
        var arr = content.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        if (!imgkey) imgkey = 'myfile'
        let mime2siffix = {
            'video/x-msvideo': 'avi',
            'video/x-dv': 'dv',
            'video/quicktime': 'mov',
            'video/x-ms-wmv': 'wm',
            'video/x-flv': 'flv',
            'video/x-matroska': 'mkv'
        };
        let suffix = mime2siffix[mime]
        if (!suffix) suffix = mime.split('/')[1]

        formData.append(imgkey, new File([u8arr], `${imgkey}.${suffix}`, {type: mime}));
        formData.append("imgkey", imgkey);
        formData.append("name", imgkey);


        return axios.request({
            url: "api/fileupload",
            method: "post",
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            transformRequest: [
                function (data) {
                    return data
                }
            ],
            timeout: 10e4
        })
    }
}
